import { atom } from 'jotai';

export const fakeAdHideCountState = atom(0);